"use client";

import { useState } from "react";

export const useHover = ({ disabled }: { disabled?: boolean } = {}) => {
  const [hasHover, setHasHover] = useState(false);

  const handleEnter = () => setHasHover(true);
  const handleLeave = () => setHasHover(false);

  return { hasHover: hasHover && !disabled, handleEnter, handleLeave };
};
